import { ActionMenu, Button } from '@pms-digital/design-system';

export interface NewMatrixMenuProps {
  /** Left out on a matrix being generated or whose generation failed (spec, règle complémentaire 2). */
  canDeriveFromThis: boolean;
  /** « Matrice vierge »: the former behaviour of the button, an empty wizard. */
  onCreateBlank: () => void;
  /** « Depuis cette matrice »: settles once the derive call is over. */
  onDeriveFromThis: () => Promise<void>;
  /** The last derive failure, shown under the toolbar button. */
  deriveError: string | null;
}

/**
 * The matrix page's « Nouvelle matrice » (issue #16, planche 08): the toolbar
 * button keeps its place, gains a chevron, and opens a two-entry menu.
 */
export function NewMatrixMenu({
  canDeriveFromThis,
  onCreateBlank,
  onDeriveFromThis,
  deriveError,
}: NewMatrixMenuProps) {
  return (
    <div className="relative">
      <ActionMenu
        align="end"
        trigger={
          <Button type="button" variant="accent" size="sm" compact iconAfter="expand_more">
            Nouvelle matrice
          </Button>
        }
        items={[
          { label: 'Matrice vierge', icon: 'description', onSelect: onCreateBlank },
          ...(canDeriveFromThis
            ? [
                {
                  label: 'Depuis cette matrice',
                  icon: 'note_add',
                  onSelect: () => void onDeriveFromThis(),
                },
              ]
            : []),
        ]}
      />
      {deriveError && (
        <p
          role="alert"
          className="absolute top-full right-0 z-20 mt-1 w-72 text-right text-caption text-danger"
        >
          {deriveError}
        </p>
      )}
    </div>
  );
}
